/**
 * Composant SignatureDialog - Dialogue de signature électronique pour les devis
 */

import { forwardRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import { PenTool, CheckCircle } from 'lucide-react';

export const SignatureDialog = forwardRef(({
  open,
  onOpenChange,
  selectedDevis,
  selectedProspect,
  onClear,
  onAccept,
  onCancel
}, ref) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="signature-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <PenTool className="h-5 w-5 text-[#8DC63F]" />
            Signature électronique - Bon pour acceptation
          </DialogTitle>
          <DialogDescription>
            Devis #{selectedDevis?.devis_id} - {(selectedDevis?.montant_total || 0).toLocaleString('fr-FR')} €
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="p-4 bg-green-50 rounded-lg border border-green-200">
            <p className="text-sm text-slate-700 mb-2">
              En signant ce devis, <strong>{selectedProspect?.prenom} {selectedProspect?.nom}</strong> accepte les conditions de la formation.
            </p>
            <p className="text-xs text-slate-500">
              Date: {new Date().toLocaleDateString('fr-FR')}
            </p>
          </div>
          
          <div>
            <Label className="text-sm font-medium mb-2 block">Dessinez votre signature ci-dessous:</Label>
            <div className="border-2 border-slate-300 rounded-lg overflow-hidden bg-white" data-testid="signature-canvas-container">
              <SignatureCanvas
                ref={ref}
                canvasProps={{
                  className: 'w-full h-40 bg-white',
                  style: { touchAction: 'none' }
                }}
                penColor="#333"
              />
            </div>
            <p className="text-xs text-slate-400 mt-1">
              Utilisez votre doigt ou votre stylet pour signer
            </p>
          </div>
        </div>
        
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={onClear} data-testid="clear-signature-btn">
            Effacer
          </Button>
          <Button variant="outline" onClick={onCancel}>
            Annuler
          </Button>
          <Button 
            onClick={onAccept}
            className="bg-[#8DC63F] hover:bg-[#7AB62F]"
            data-testid="confirm-signature-btn"
          >
            <CheckCircle className="h-4 w-4 mr-2" />
            Valider et signer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});

SignatureDialog.displayName = 'SignatureDialog';

export default SignatureDialog;
